export enum CaseDetailsMobileViewQueryParams {
  DISPLAYED_CONTENT = 'displayedContent',
  SCROLL_TO = 'scrollTo',
}

export enum CaseDetailsMobileViewQueryParamsScrollToValue {
  PRICE_SUMMARY = 'priceSummary',
  RETAIL_MARKET = 'retailMarket',
}
